import {
	isValidPhoneNumber,
	validatePhoneNumberLength,
} from "libphonenumber-js";

const PhoneNumberService = {
	formatPhoneNumber: (number: string, forRender: boolean = true) => {
		var cleaned = number.trim().replace(/\D/g, "");
		var match = cleaned.match(/^(\d{1})?(\d{3})(\d{3})(\d{4})$/);
		if (match && forRender) {
			return `+1 (${match[2]}) ${match[3]}-${match[4]}`;
		}
		if (match && !forRender) {
			return `+1${match[2]}${match[3]}${match[4]}`;
		}
		return "";
	},
	isPhone: (number: string) => {
		return isValidPhoneNumber(number, "US");
	},
	extractPhone: (numbers: string) => {
		const matchingRegex =
			/[!@#$%^&*)(+=._-]*?(?:\+?(\d{1,3}))\d{1,3}[!@#$%^&*)(+=._-]*?\d{1,3}[!@#$%^&*)(+=._-]*?\d{1,}[!@#$%^&*)(+=._-]*|(?:\+?(\d{1,3}))?[- (]*(\d{3})[- )]*(\d{3})[- ]*(\d{4})(?: *x(\d+))?\b|(?:\+?(\d{1,3}))?[- (]*(\d{3})[- )]*([0-9-]{1,})/g;

		return numbers.match(matchingRegex) as string[];
	},
	checkNumberLength: (number: string) => {
		return validatePhoneNumberLength(number, "US");
	},
};

export default PhoneNumberService;
